import APIController from '../core-api-controller';

export const fetchAgentSalesApi = (paramsObj = {}) => {
  const path = `${APIController.endpointApi}/agent_sales`;
  return APIController.getApiCallback(path, paramsObj);
};

export const markSaleCompleteApi = (data = {}) => {
  const path = `${APIController.endpointApi}/agent_sales/mark_as_complete`;
  return APIController.putCallback(path, data);
};

export const fetchUserAgentSales = (id = '', paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/agent_sales/my_sales${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};
